/**
 * apps/web/src/lib/antd-statics.ts — the statics bridge.
 *
 * antd 6 renders `message.success()` / `notification.warning()` UNTHEMED when
 * imported statically in CSS-variable mode: the static instance is created
 * outside every `ConfigProvider`, so it never sees `cropmateTheme`.
 *
 * The fix (14-theme.md §8.2, 00-stack.md §4.5): capture the hook instances
 * ONCE inside `<AntApp>` and export them for non-React call sites — the fetch
 * wrapper and the TanStack Query MutationCache.
 */
import type { MessageInstance } from 'antd/es/message/interface';
import type { NotificationInstance } from 'antd/es/notification/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';

export interface AntStatics {
  message: MessageInstance | null;
  notification: NotificationInstance | null;
  modal: Omit<ModalStaticFunctions, 'warn'> | null;
}

export const statics: AntStatics = {
  message: null,
  notification: null,
  modal: null,
};

export function bindStatics(next: {
  message: MessageInstance;
  notification: NotificationInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
}): void {
  statics.message = next.message;
  statics.notification = next.notification;
  statics.modal = next.modal;
}
